import { render, staticRenderFns } from "./ProviderFeatureEmptyState.vue?vue&type=template&id=68597feb&scoped=true&"
import script from "./ProviderFeatureEmptyState.vue?vue&type=script&lang=ts&"
export * from "./ProviderFeatureEmptyState.vue?vue&type=script&lang=ts&"
import style0 from "./ProviderFeatureEmptyState.vue?vue&type=style&index=0&id=68597feb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68597feb",
  null
  
)

export default component.exports